import { BaseMapSource } from './basemap.model';

export const BaseMaps: BaseMapSource[] = [
    {
        name: 'Dark Gray Canvas',
        id: '77b3505cd7ae4484ac3fc253a50ee9c8',
        basemap: null,
        mainBasemap: false,
    },
    {
        name: 'Light Gray Canvas',
        id: 'c5b0e6e1ded840639b8b4ff3d9927145',
        basemap: null,
        mainBasemap: false,
    },
    {
        name: 'Imagery',
        id: '86de95d4e0244cba80f0fa2c9403a7b2',
        basemap: null,
        mainBasemap: false,
    },
    {
        name: 'Imagery Hybrid',
        id: '0d17ba68a8f64c278e7e2e7864e1069d',
        basemap: null,
        mainBasemap: false,
    },
    {
        name: 'Forest Service Base Map',
        id: '1449df9001b5481ca52a42806962a150',
        basemap: null,
        mainBasemap: false,
    },
    {
        name: 'Topographic',
        id: '668f436dc2dc4f2c83ceb0c064380590',
        basemap: null,
        mainBasemap: false,
    },
    {
        name: 'USA Topo Maps',
        id: '42e152344ffb46f28ba49d7f4d0b91ab',
        basemap: null,
        mainBasemap: false,
    },
    {
        name: 'USGS National Map',
        id: '6d9fa6d159ae4a1f80b9e296ed300767',
        basemap: null,
        mainBasemap: false,
    },
    {
        name: 'National Geographic Style Map',
        id: '752d5eb93f38494082ae19bd718fac98',
        basemap: null,
        mainBasemap: true,
    },
    {
        name: 'NPS Tile Layer',
        id: '0644b9dc136843118d632137901657aa',
        basemap: null,
        mainBasemap: false,
    },
    {
        name: 'Streets',
        id: '22fb75c0fa5a4c88b8ca4c4b8ae5c90b',
        basemap: null,
        mainBasemap: false,
    },
    {
        name: 'Terrain with Labels',
        id: 'd9eb1392e6504930b5fbd9689ac32ff4',
        basemap: null,
        mainBasemap: false,
    },
];
